var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-key paged-key"},[_c('p',[_c('span',{staticClass:"paged-key-label"},[_vm._v("\n      "+_vm._s(_vm.keyTitle)+"\n    ")]),_vm._v(" "),_vm._l((_vm.showStatuses),function(key){return _c('span',[_c('purchase-status-badge',{attrs:{"status":key}})],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62276b35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseKey.vue
// module id = 1204
// module chunks = 1